var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaretUpSm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 4,
    viewBox: "0 0 8 4",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.78787 0.212132C3.90503 0.0949745 4.09497 0.0949745 4.21213 0.212132L7.48787 3.48787C7.67686 3.67686 7.54301 4 7.27574 4H0.724264C0.456993 4 0.323142 3.67686 0.512132 3.48787L3.78787 0.212132Z",
    fill: "#BBBBBB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaretUpSm);
export default __webpack_public_path__ + "static/media/caret-up-sm.f9cf9e6c58821ef69efb4b83a8edba80.svg";
export { ForwardRef as ReactComponent };